module.exports = "/React/dist/0e468441f8983f6d888ef582a6aeed17.gif";